import type { ShiftCategory, ShiftRole, ShiftStatus } from "@/features/shifts/types";
import type { VenueCategory } from "@/features/venues/types";
import type { Certification, WorkerStatus } from "@/features/workers/types";

export type ApplicationStatus =
  | "PENDING"
  | "INTERESTED"
  | "PASSED"
  | "CONFIRMED"
  | "WITHDRAWN";

/** States a venue can move an application between without finalizing. */
export type ShortlistStatus = "PENDING" | "INTERESTED" | "PASSED";

export const SHORTLIST_STATUSES: ShortlistStatus[] = ["PENDING", "INTERESTED", "PASSED"];

export const APPLICATION_STATUS_LABELS: Record<ApplicationStatus, string> = {
  PENDING: "Pending",
  INTERESTED: "Interested",
  PASSED: "Passed",
  CONFIRMED: "Confirmed",
  WITHDRAWN: "Withdrawn",
};

export interface Application {
  id: string;
  shift_id: string;
  worker_id: string;
  status: ApplicationStatus;
  applied_at: string;
}

export interface MyApplication extends Application {
  shift_role: ShiftRole;
  shift_event_name: string | null;
  shift_date: string;
  shift_end_date: string | null;
  shift_start_time: string;
  shift_end_time: string;
  shift_status: ShiftStatus;
  pay_rate: string;
  is_urgent: boolean;
  transportation_offered: boolean;
  shift_category: ShiftCategory | null;
  venue_id: string;
  venue_name: string;
  venue_address: string;
  venue_category: VenueCategory | null;
}

export interface Applicant {
  application_id: string;
  worker_id: string;
  name: string;
  photo_url: string | null;
  city: string | null;
  certifications: Certification[];
  status: ApplicationStatus;
  worker_status: WorkerStatus;
  rating_avg: number | null;
  shift_count: number;
  applied_at: string;
}

export interface ApplicantList {
  applicants: Applicant[];
}
